import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginComponent } from './module/login/login.component';
import { FormsModule } from '@angular/forms';
import { MainPageComponent } from './module/main-page/main-page.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { GoogleMapsModule } from '@angular/google-maps';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, 
    LoginComponent,
    FormsModule, 
    MainPageComponent,
    ToastModule,
    ConfirmDialogModule,
    NgxSpinnerModule,
    GoogleMapsModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'gestionTaxiweb';
  
}
